import React, { FC, useRef } from 'react';
import { Modal, ModalProps } from 'react-bootstrap';
import { LoadingButton } from './loading-button';

interface ConfirmDialogProps extends ModalProps {
	title: string;
	cancelText?: string;
	confirmText?: string;
	onConfirm(event: React.MouseEvent<HTMLButtonElement, MouseEvent>): void;
	disabled?: boolean;
	hideConfirm?: boolean;
	isLoading?: boolean;
}

export const ConfirmDialog: FC<ConfirmDialogProps> = ({
	title,
	children,
	cancelText,
	confirmText,
	onConfirm,
	disabled,
	hideConfirm,
	isLoading = false,
	...props
}) => {
	const confirmButtonRef = useRef<HTMLButtonElement>(null);

	const handleOnEntered = () => {
		confirmButtonRef.current?.focus();
	};

	return (
		<Modal centered {...props} onEntered={handleOnEntered}>
			<fieldset disabled={disabled}>
				<Modal.Header closeButton>
					<Modal.Title>{title}</Modal.Title>
				</Modal.Header>
				<Modal.Body>{children}</Modal.Body>
				{(cancelText || confirmText) && (
					<Modal.Footer>
						<div className="text-right">
							{cancelText && (
								<LoadingButton
									isLoading={isLoading}
									type="button"
									className="mr-2"
									variant="outline-primary"
									onClick={props.onHide}
								>
									{cancelText}
								</LoadingButton>
							)}
							{hideConfirm ? (
								undefined
							) : (
								<LoadingButton
									ref={confirmButtonRef}
									isLoading={isLoading}
									type="button"
									onClick={onConfirm}
								>
									{confirmText}
								</LoadingButton>
							)}
						</div>
					</Modal.Footer>
				)}
			</fieldset>
		</Modal>
	);
};
